import { useEffect, useState } from 'react';
import { IProduct } from '@interfaces';
import { BundleModalBody } from './bundle';
import { useAddAgeBundle } from './utils';
import Loader from '../presentational/loader/loader';
import { useShop } from '@v2/store/shop.selectors';
import { mapVeggieBundle } from '@v2/components/pages/shop/utils';


export default function AgeBundleModal({ bundle: bundlePromise, readonly, hide }
    : { bundle: Promise<IProduct>, readonly?: boolean, hide: (() => void) }
) {
    const [bundle, setBundle] = useState(null);
    const addAgeBundle = useAddAgeBundle();
    const { veganOnly } = useShop();

    useEffect(() => {
        bundlePromise.then(setBundle);
    }, []);

    return bundle
                ? <BundleModalBody bundle={bundle} readonly={readonly} addAction={() => addAgeBundle(veganOnly ? mapVeggieBundle(bundle) : bundle, veganOnly)} close={hide} />
                : <Loader style={{marginTop: '35vh'}} />;
}